import { Component } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
import { MatRadioModule } from '@angular/material/radio';


import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, FormControl, Validators, AbstractControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { ApiserviceService } from '../../shared-components/apiservice/apiservice.service';
import { RxReactiveFormsModule, RxwebValidators } from '@rxweb/reactive-form-validators';
import { RxWebValidatorHelper } from '../../ui-framework/shared-code/form-control-validation/rxweb-validators';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-mobile-view',
  imports: [MatSelectModule, MatIconModule, MatButtonModule, MatRadioModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
     CommonModule, FormsModule, ReactiveFormsModule, RxReactiveFormsModule
   ],
  templateUrl: './mobile-view.component.html',
  styleUrl: './mobile-view.component.scss'
})
export class MobileViewComponent {

    reactiveForm: FormGroup<MyForm>;
    hidePassword = true;
    message: any = null;
    messagetwo: any = null;
    messagereturn: any = null;
      // Separate file name holders
    kitFileName: string = '';
    materialFileName: string = '';
    // To store actual file objects
    selectedFiles: { [key: string]: File } = {};

    constructor(private fb: FormBuilder,
        private trainingService: ApiserviceService,
        private location: Location) {
        
        this.reactiveForm = new FormGroup(new MyForm());

      }
     // Select file
      // onFileSelected(event: any, controlName: keyof MyForm) {
      //   const file = event.target.files[0];
      //   if (file) {
      //     this.selectedFiles[controlName] = file;

      //     // ✅ Safe way to set value
      //     const control = this.reactiveForm.get(controlName);
      //     if (control) control.setValue(file);

      //     // Update file name for display
      //     if (controlName === 'kitFile') {
      //       this.kitFileName = file.name;
      //     } else if (controlName === 'materialFile') {
      //       this.materialFileName = file.name;
      //     }
      //     // Trigger validation
      //     if (control) control.markAsTouched();
      //   }
      // }
      // onFileSelected(event: any, controlName: keyof MyForm) {
      //   const file = event.target.files[0];
      //   if (file) {
      //     const control = this.reactiveForm.get(controlName);
      //     if (control) {
      //       control.setValue(file);
      //       control.markAsTouched(); // triggers validation messages
      //       control.updateValueAndValidity();  
      //     }

      //     if (controlName === 'kitFile') this.kitFileName = file.name;
      //     if (controlName === 'materialFile') this.materialFileName = file.name;
      //   }
      // }
      onFileSelected(event: any, controlName: string) {
        const file = event.target.files[0] ?? null; // null if nothing selected
        const control = this.reactiveForm.get(controlName);

        if (control) {
          control.setValue(file);                     // set the selected file
          control.markAsTouched();                    // mark as touched to trigger validation
          control.updateValueAndValidity();           // run validators immediately
        }

        // optional: store file name for display
        if (controlName === 'kitFile') this.kitFileName = file?.name ?? '';
        if (controlName === 'materialFile') this.materialFileName = file?.name ?? '';
      }



    

      ontrainingSubmit() 
      {
        if (this.reactiveForm.valid) {
          const formData = new FormData();

          // ✅ Use keyof MyForm for type safety
          (Object.keys(this.reactiveForm.value) as (keyof MyForm)[]).forEach(key => {
            const value = this.reactiveForm.value[key];

            // Append only if value is not null/undefined
            if (value !== null && value !== undefined) {
              // For file controls, append the actual File object
              if (value instanceof File) {
                formData.append(key, value, value.name);
              } else {
                formData.append(key, value.toString());
              }
            }
          });

          // 🔹 Create display object for debug/preview
          const displayData: any = {};
          formData.forEach((value, key) => {
            displayData[key] = value instanceof File ? value.name : value;
          });
          this.messagetwo = displayData;

          // 🚀 Send to API
          this.trainingService.saveTraining(formData).subscribe({
            next: (res) => {
              this.message = res?.message || 'Training details saved successfully!';
              this.messagereturn = res;

              // Reset form & file names
              this.reactiveForm.reset({ active: true });
              this.kitFileName = '';
              this.materialFileName = '';
            },
            error: (err) => {
              console.error('API Error:', err);
              this.message = 'Error saving training details. Please try again.';
            }
          });

        } else {
          alert('Please fill all required fields');
        }
      }

    // getErrorMessages(control: AbstractControl, fieldName?: string): string[] {
    //   const messages: string[] = [];

    //   if (!control || !control.errors || (!control.dirty && !control.touched)) {
    //     return messages;
    //   }

    //   const errors = control.errors;
    //   //console.error(errors);
    //   for (const errorName of Object.keys(errors)) {
    //     messages.push(errors[errorName]?.message);
    //   }

    //   return messages;
    // }
    getErrorMessages(control: AbstractControl, fieldName?: string): string[] {
      const messages: string[] = [];

      if (!control || !control.errors || (!control.dirty && !control.touched)) {
        return messages;
      }

      const errors = control.errors;

      for (const errorName of Object.keys(errors)) {
        const errorValue = errors[errorName];

        if (typeof errorValue === 'string') {
          messages.push(errorValue); // for your invalidDate string
        } else if (errorValue && errorValue.message) {
          messages.push(errorValue.message); // for RxwebValidators with message property
        } else {
          // fallback: push errorName
          messages.push(errorName);
        }
      }

      return messages;
    }


     

    refreshForm() {
      this.reactiveForm.reset({ active: true });
      this.kitFileName = '';
      this.materialFileName = '';
      this.message = null;
    }

    goBack() {
      this.location.back();
    }
}

class MyForm {
    trainingCode = new FormControl<string | null>('', {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Training Code`,
        required: true, 
        minLength: 1,
        maxLength: 6

      })
    });

    trainingTitle = new FormControl<string | null>('', {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Grade Name`,
        required: true, 
      })
    });

    type = new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Type`,
        required: true
      
      })
    });
    category= new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Category`,
        required: true
      
      })
    });

    Subcategory= new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Sub Category`,
        required: true
      
      })
    });

    level= new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Level`,
        required: true
      
      })
    });

    participantsType= new FormControl<string | null>(null, {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Participant Type`,
        required: true
      
      })
    });

    duration= new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Duration`,
        required: true
      
      })
    });

    mode= new FormControl<string | null>(null, {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Mode`,
        required: true
      
      })
    });

    frequency= new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Training Frequency`,
        required: true
      
      })
    });

    budgetHead= new FormControl<string | null>(null, {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Budget Head`,
        required: true
      
      })
    });

    residential= new FormControl<string | null>(null, {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Residential`,
        required: true
      
      })
    });

    residentialAmount= new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Residential Amount`,
        required: true,
        minNumber:0,
        decimalPlace:2
      })
    });

    nonResidentialAmount= new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Non-Residential Amount`,
        required: true,
        minNumber:0,
        decimalPlace:2
      })
    });

    memoNo= new FormControl<string | null>(null, {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Budget Head`,
        required: true
      
      })
    });

    // ✅ Add these for file uploads
    kitFile = new FormControl<File | null>(null, 
      RxWebValidatorHelper.getFileValidator({
        propertyName: 'Training Kit',
        required: true,
        maxFileSize: 5 * 1024 * 1024, // 5 MB
        fileType: ['pdf','docx','xlsx','jpg','png']
      })
    );

    materialFile = new FormControl<File | null>(null, 
      RxWebValidatorHelper.getFileValidator({
        propertyName: 'Training Material',
        required: true,
        maxFileSize: 5 * 1024 * 1024,
        fileType: ['pdf','docx','xlsx','jpg','png']
      })
    );



    active = new FormControl<boolean>(true);

    refreshment= new FormControl<string | null>(null, {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Refreshment`,
        required: true
      
      })
    });

    inactiveFrom = new FormControl<Date | null>(null, {
      validators: RxWebValidatorHelper.futureOrTodayDateValidator({
        propertyName: 'Inactive From',
        required: true
      })
    });

    remarks = new FormControl<string | null>('');

    mobile= new FormControl<number | null>(null, {
    validators: RxWebValidatorHelper.getNumberValidator(
      {
        propertyName: `Mobile No`,
        required: true,
        mobilePattern: /^\d{10}$/
      })
    });

    email= new FormControl<string | null>(null, {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `email`,
        required: true,
        emailPattern: true 
        // /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      })
    });
    password= new FormControl<string | null>(null, {
    validators: RxWebValidatorHelper.getStringValidator(
      {
        propertyName: `Password`,
        required: true,
        /*
        must contain uppercase, lowercase, digit, special character and be at least 8 characters long
        */
        passwordPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/  
        // /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      })
    });

}
